<template>
  <div class="p-absolute t-0 w-100">
    <div class="d-flex ai-center bg-test flex-column">
      <div class="d-flex flex-column bg-white qa-block p-absolute">
        <div class="d-flex jc-center">
          <span class="dot-title">
            {{ $t("QA.title") }}
          </span>
        </div>
        <div class="d-flex expansion-block">
          <v-expansion-panels flat multiple v-if="qas.length > 0">
            <v-expansion-panel
              v-for="(qa, idx) in qas"
              :key="'qa' + idx"
              style="margin-bottom: 2rem;"
            >
              <v-expansion-panel-header>
                <template v-slot:actions>
                  <v-icon class="custom-arrow" color="#FFC600">$expand</v-icon>
                </template>
                <span class="custom-header">{{ qa["question" + locale] }}</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="custom-content">
                {{ qa["answer" + locale] }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div class="w-100 d-flex jc-center" v-else>
            <v-progress-circular
              indeterminate
              color="orange"
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import { mapMutations } from "vuex";
export default {
  components: { Footer },
  data() {
    return {
      qas: [],
      loading: true
    };
  },
  computed: {
    locale() {
      if (this.$i18n.locale === "zh-TW") return "TW";
      else if (this.$i18n.locale === "zh-CN") return "CN";
      else if (this.$i18n.locale === "en") return "EN";
      return "TW";
    }
  },
  methods: {
    ...mapMutations("header", ["setHeaderAttr"]),
    async fetch() {
      const res = await this.$http.get("qas");
      this.qas = res.data.items;
      this.loading = false;
    }
  },
  created() {
    this.setHeaderAttr({
      background: "transprent",
      fixedTop: true
    });
    this.fetch();
  }
};
</script>

<style lang="sass" scoped>
.bg-test
  background-image: url("/assets/bg/bg_homepage_FAQ_header.png")
  background-size: 100%
  padding-top: 10rem
  min-height: 48.6rem
  margin-bottom: 29.85rem
.qa-block
  padding-bottom: 3rem
  z-index: 2
  width: 66rem
  .dot-title
    padding-top: 2.2rem
    padding-bottom: 0.55rem
    margin-bottom: 4.75rem
    font-size: 2.75rem
    color: #ffa20a
    letter-spacing: 0.4585rem
    text-indent: 0.4585rem
    border-bottom: 2px dashed #ffa20a

.expansion-block
  padding-left: 5rem
  padding-right: 5rem
  max-height: 60rem
  overflow-y: overlay
  .custom-arrow
    order: 0
    font-size: 2.5rem
    color: #ffc600
  .custom-header
    order: 1
    font-size: 1.5rem
    color: #FFA20A
    letter-spacing: 0.25rem
  .custom-content
    background: #F8F8F8 !important
    font-size: 1.25rem
    color: #595959
    letter-spacing: 0.2085rem
    //padding: 1.5rem 1rem 1.5rem 2.5rem
    ::v-deep .v-expansion-panel-content__wrap
      padding: 1.5rem 1rem 1.5rem 2.5rem !important
  .v-expansion-panel-header
    padding: 0
</style>
